import { render } from "./new_signature_step.vue?vue&type=template&id=248b2464&scoped=true"
import script from "./new_signature_step.vue?vue&type=script&lang=js"
export * from "./new_signature_step.vue?vue&type=script&lang=js"

import "./new_signature_step.vue?vue&type=style&index=0&id=248b2464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248b2464"]])

export default __exports__